import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { logoutAccount } from '../actions/logout';
import { openInviteModal } from '../actions/invite';
import { getAuthenticatedIsAdmin } from '../selectors/auth';
import Footer from '../components/Footer';

class FooterContainer extends Component {
  constructor(props) {
    super(props);

    this.handleLogout = this.handleLogout.bind(this);
  }

  handleLogout() {
    this.props.logoutAccount(this.props.token);
  }

  render() {
    return <Footer handleLogout={this.handleLogout} {...this.props} />;
  }
}

FooterContainer.defaultProps = {
  token: null
};

FooterContainer.propTypes = {
  token: PropTypes.string,
  logoutAccount: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired, // eslint-disable-line
  isAuthenticated: PropTypes.bool.isRequired
};

function mapStateToProps(state) {
  const isAdmin = state.auth.hasToken ? getAuthenticatedIsAdmin(state) : false;

  return {
    token: state.auth.token,
    location: state.router.location,
    isAuthenticated: state.auth.hasToken && state.auth.hasProfile,
    isAdmin
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logoutAccount,
      onInviteClick: openInviteModal
    },
    dispatch
  );
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(FooterContainer)
);



// WEBPACK FOOTER //
// ./src/containers/FooterContainer.js